import axios from 'axios'
import Qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
request.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-XSRF-TOKEN'] = getToken() ? getToken() : "123456" // 让每个请求携带自定义token 请根据实际
  } else {
    config.headers['X-XSRF-TOKEN'] = "123456"
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
request.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    // console.log("response.data===>", res);
    if (res.code && res.code !== 0) {
      if (response.config.url.indexOf('autohome/getPortrait') > -1) {
        Message({
          message: '暂无用户画像，无法查看',
          type: 'error',
          duration: 3 * 1000
        })
      }
      // 401:未登录;
      if (res.code === 401 || res.code === 400003) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      if (res.code == 1) {
        Message({
          message: response.data.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      return Promise.reject(response.data.message)
    } else if (res.code == 0) {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

function deleteEmptyProperty(obj) {
  var object = obj;
  for (var i in object) {
    var value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          delete object[i];
          continue;
        }
      }
      deleteEmptyProperty(value);
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      }
    }
  }
  return object;
}

function getRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET');
}

function getRequestJson(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET', 1);
}

function postRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST');
}

function postRequestJson(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST', 1);
}

function request_fuc(url, params, method, isJson) {
  return request({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? (isJson == 1 ? JSON.stringify(params) : params) : null,
    params: method === 'GET' ? params : null,
    // 请求头携带信息，类型默认为form,键值模式，传参为1
    headers: {
      'Content-Type': isJson && isJson === 1 ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    transformRequest: [function (data) {
      if (isJson !== 1) {
        data = Qs.stringify(data);
      }
      return data;
    }],
  })
}

export default {
  request,
  getRequest,
  getRequestJson,
  postRequest,
  postRequestJson
}



// WEBPACK FOOTER //
// ./src/utils/request.js